/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */

import 'dayjs/locale/lt';

import { Box, Card, CardContent, debounce, Typography } from '@mui/material';
import {
 DataGridPremium,
 GRID_CHECKBOX_SELECTION_COL_DEF,
 GridColDef,
 GridColumnOrderChangeParams,
 GridFilterModel,
 GridGroupingColDefOverride,
 GridInitialState,
 GridPaginationModel,
 GridRenderCellParams,
 GridRowParams,
 GridSortModel,
 MuiEvent,
} from '@mui/x-data-grid-premium';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
 Dispatch,
 memo,
 SetStateAction,
 useCallback,
 useEffect,
 useLayoutEffect,
 useMemo,
 useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { FieldsConfigProvider } from '../../../contexts/useFieldsConfigDialog';
import { usePage } from '../../../contexts/usePageContext';
import {
 getConfigStorageItem,
 setConfigStorageItem,
} from '../../../hooks/useConfigStorage';
import {
 changeCurrentPreset,
 getClientConfigurationsStart,
 getCurrentPresetStart,
} from '../../../redux/clientConfiguration/clientConfigurationSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { RootState } from '../../../redux/store';
import ColModal from '../ColModal';
import ResultModal from '../EditModal';
import FilterMenu from '../FilterMenu';
import FilterSidebar from '../FilterSidebar';
import InfoSidebar from '../InfoSidebar';
import LimitModal from '../LimitModal';
import TranslationModal from '../TranslationModal';
import CustomColumnMenuWrapper from './CustomColumnMenu';
import DataGridPagination from './GridPagination';
import gridSlotsIcons from './gridSlotsIcons';
import GridToolbar from './GridToolbar';
import { renderColObj, renderColWithStructure } from './renderCol';
import RowMenu from './RowMenu';
import dataGridStyles from './styles';
import { GRID_DEFAULT_LOCALE_TEXT } from './translation';
import { TableModalState, TProps } from './types';
import {
 constructRows,
 handleFilterModelChange,
 prepareFilters,
 prepareSort,
} from './utils';

// Do not access state values directly. The state itself is not considered a public API and its structure can change.
// const paginationModel = gridPaginationModelSelector(apiRef);

declare module '@mui/x-data-grid' {
 interface ToolbarPropsOverrides {
  setCreateModalOpen: Dispatch<SetStateAction<boolean>>;
  createModalOpen: boolean;
  modalState: TableModalState;
  setModalState: Dispatch<SetStateAction<TableModalState>>;
 }
}
const XTable = memo((props: TProps) => {
 const dispatch = useAppDispatch();
 const { pageName } = usePage();
 const { t } = useTranslation();
 const {
  fetchData,
  fetchDataParams,
  isServerMode = false,
  noUrlParams = false,
  defaultPageSize = 50,
  rowCount,
  loading = false,
  rows,
  apiRef,
  table,
 } = props;
 const success = useAppSelector((state: RootState) => {
  const pageState = state[pageName as keyof RootState];
  return pageState && 'success' in pageState ? pageState.success : false;
 });

 const [isInit, setIsInit] = useState(false);
 const [currentId, setCurrentId] = useState<number | undefined>();
 const [modalState, setModalState] = useState<TableModalState>({
  id: -1,
  action: 'create',
 });
 const [colModalOpen, setColModalOpen] = useState(false);
 const [filterSidebarOpen, setFilterSidebarOpen] = useState(false);
 const [createModalOpen, setCreateModalOpen] = useState(false);

 const [filterMenuState, setfilterMenuState] = useState<{
  anchorElement: HTMLDivElement | HTMLButtonElement | null;
  colName: string;
 } | null>(null);

 const [limitModalState, setLimitModalState] = useState<{
  anchorElement: HTMLDivElement | null;
  colName: string;
 } | null>(null);

 const [translationModalState, setTranslationModalState] = useState<{
  anchorElement: HTMLDivElement | null;
  colName: string;
 } | null>(null);

 useEffect(() => {
  if (currentId) {
   setFilterSidebarOpen(false);
  }
 }, [currentId]);
 useEffect(() => {
  if (filterSidebarOpen) {
   setCurrentId(undefined);
  }
 }, [filterSidebarOpen]);

 const checkboxCol = {
  ...GRID_CHECKBOX_SELECTION_COL_DEF,
  width: 56,
  maxWidth: 56,
 };
 const actionsCol = renderColObj(
  { field: 'actions' },
  '',
  undefined,
  (params: GridRenderCellParams<{ row: Record<string, unknown> }>) => (
   <RowMenu
    row={params.row}
    setCurrentId={setCurrentId}
    setModalState={setModalState}
   />
  ),
 );

 const structure = useSelector((state: RootState) => {
  const pageState = state[pageName as keyof RootState];
  return pageState && 'structure' in pageState ? pageState.structure : [];
 });

 const currentColumnsPreset = useSelector(
  (state: RootState) =>
   state.clientConfiguration.currentColumnsPreset?.[pageName] || null,
 );
 const presetsColumns = useSelector(
  (state: RootState) => state.clientConfiguration.presetsColumns,
 );

 const [columnsState, setColumnsState] = useState<GridColDef[]>([]);

 useEffect(() => {
  if (!presetsColumns && !currentColumnsPreset) {
   dispatch(getClientConfigurationsStart({ cached: false }));
  } else if (presetsColumns?.data?.[0] && !currentColumnsPreset) {
   dispatch(
    changeCurrentPreset({
     page: pageName,
     type: 'columns',
     preset: presetsColumns?.data?.[0],
     temp: false,
    }),
   );
  }
 }, [presetsColumns, currentColumnsPreset]);

 useEffect(() => {
  if (!structure.length) return;

  // this loads columns into table when preset is changed
  if (currentColumnsPreset) {
   const colsObj = renderColWithStructure(
    currentColumnsPreset?.columns,
    structure,
   );
   setColumnsState(colsObj);
  }
 }, [currentColumnsPreset, structure]);

 const [filter, setFilter] = useState<GridFilterModel>();
 const [sortModel, setSortModel] = useState<GridSortModel>([]);
 //  const urlParams = !noUrlParams
 //   ? queryString.parse(window.location.search)
 //   : {};
 const defaultPaginationModel = {
  page: 0,
  pageSize: defaultPageSize,
  loading: false,
 };

 const [paginationModel, setPaginationModel] = useState<GridPaginationModel>(
  defaultPaginationModel,
 );

 const wrapFetchData = () => {
  if (typeof fetchData !== 'function') return false;

  const filters = prepareFilters(
   apiRef.current.state.filter.filterModel.items,
   structure,
  );

  const sort = prepareSort(apiRef?.current?.getSortModel(), structure); // or sortModel?

  fetchData({
   ...fetchDataParams,
   sort,
   limit: paginationModel.pageSize,
   skip: paginationModel.page * paginationModel.pageSize,
   ...filters,
  });

  // setTimeout(() => {
  //  // trigger column resize
  //  //  console.log('timeout');
  //  apiRef.current.autosizeColumns({
  //   includeHeaders: false,
  //   includeOutliers: true,
  //   outliersFactor: 5.5,
  //   // expand: true,
  //  });
  // }, 1500);
  return true;
 };
 useEffect(() => {
  if (success?.['getTable' as keyof typeof success]) {
   setTimeout(() => {
    apiRef.current.autosizeColumns({
     columns: columnsState
      .filter((col) => col.width === undefined)
      .map((col) => col.field),
     includeHeaders: false,
     includeOutliers: true,
    });
   }, 100);
  }
 }, [success?.['getTable' as keyof typeof success]]);

 useEffect(() => {
  if (apiRef.current) {
   apiRef.current.setModalState = setModalState;
   apiRef.current.setCurrentId = setCurrentId;
   apiRef.current.setCreateModalOpen = (isOpen) => setCreateModalOpen(isOpen);
   apiRef.current.filterSidebarOpen = filterSidebarOpen;
   apiRef.current.setFilterSidebarOpen = (isOpen) =>
    setFilterSidebarOpen(isOpen);
   apiRef.current.fetchData = wrapFetchData;
   apiRef.current.colModalOpen = colModalOpen;
   apiRef.current.setColModalOpen = (isOpen) => setColModalOpen(isOpen);
   apiRef.current.setLimitModalState = (isOpen) => setLimitModalState(isOpen);
   apiRef.current.setFilterMenuState = (isOpen) => setfilterMenuState(isOpen);
   apiRef.current.setTranslationModalState = (isOpen) =>
    setTranslationModalState(isOpen);
  }
 }, [apiRef]);

 useEffect(() => {
  if (isInit) {
   wrapFetchData();
  }
 }, [filter, sortModel, paginationModel]);

 const [initialState, setInitialState] = useState<GridInitialState>({
  pinnedColumns: { right: ['actions'] },
  // rowGrouping: {
  //  model: ['Sender'],
  // },
  // aggregation: {
  //  model: {
  //   Neto: 'sum',
  //  },
  // },
 });

 // When a column is resized, update its width in state and localStorage
 const handleColumnResize = debounce((params: any) => {
  setColumnsState((prevState) =>
   prevState?.map((col) =>
    col.field === params.colDef.field ? { ...col, width: params.width } : col,
   ),
  );

  const newPreset = {
   name: currentColumnsPreset?.name || 'Custom',
   columns: currentColumnsPreset?.columns
    ? currentColumnsPreset.columns.map((col: any) =>
       col.field === params.colDef.field
        ? { ...col, width: Math.round(params.width) }
        : col,
      )
    : [],
  };

  setConfigStorageItem({
   page: pageName,
   key: 'columns',
   value: newPreset,
  });
  dispatch(
   changeCurrentPreset({
    page: pageName,
    type: 'columns',
    preset: newPreset, // Provide a default value
    temp: true,
   }),
  );
 }, 300);

 //  console.log(columnsState, currentColumnsPreset);
 // When columns are reordered, update the order in state and localStorage
 const handleColumnOrderChange = (params: GridColumnOrderChangeParams) => {
  setColumnsState((prevColumns) => {
   const { column, targetIndex } = params;
   const currentIndex = prevColumns.findIndex(
    (col) => col.field === column.field,
   );

   if (currentIndex === -1) return prevColumns; // Column not found, return unchanged array

   // Create a shallow copy of the previous columns
   const updatedColumns = [...prevColumns];

   // why -1?

   // Remove the column from its current position
   updatedColumns.splice(params.oldIndex - 1, 1);
   //  // Insert the column at the target index
   updatedColumns.splice(params.targetIndex - 1, 0, column);

   const newPreset = {
    name: currentColumnsPreset?.name || 'Custom',
    columns:
     updatedColumns.map((col) => ({ field: col.field, width: col.width })) ||
     [],
   };

   setConfigStorageItem({
    page: pageName,
    key: 'columns',
    value: newPreset,
   });

   dispatch(
    changeCurrentPreset({
     page: pageName,
     type: 'columns',
     preset: newPreset, // Provide a default value
     temp: true,
    }),
   );

   return updatedColumns;
  });
 };

 const saveSnapshot = useCallback(() => {
  // console.log(
  //  'saveSnapshot callback',
  //  columnsState,
  //  apiRef?.current?.getAllColumns(),
  // );
  if (apiRef?.current?.exportState && localStorage) {
   const currentState = apiRef.current.exportState();
   localStorage.setItem(
    `table_state_${pageName}`,
    JSON.stringify(currentState),
   );
  }
 }, [apiRef]);

 useLayoutEffect(() => {
  // console.log('useLayoutEffect');
  const stateFromLocalStorage = JSON.parse(
   localStorage?.getItem(`table_state_${pageName}`) || '{}',
  );

  const columnsFromLocalStorage =
   getConfigStorageItem(pageName)?.columns?.columns; // bad
  // console.log(
  //  `columnsFromLocalStorage`,
  //  structure,
  //  columnsFromLocalStorage,
  //  //  renderColWithStructure(columnsFromLocalStorage, structure),
  // );

  setSortModel(stateFromLocalStorage?.sorting?.sortModel || []);
  setFilter(stateFromLocalStorage?.filter?.filterModel || { items: [] });
  setPaginationModel(
   stateFromLocalStorage?.pagination?.paginationModel || defaultPaginationModel,
  );
  // if (structure.length && !currentColumnsPreset) {
  //  setColumnsState(renderColWithStructure(columnsFromLocalStorage, structure));
  // }
  if (structure.length) {
   setColumnsState(
    columnsFromLocalStorage
     ? renderColWithStructure(columnsFromLocalStorage, structure)
     : [],
   );
  }

  setInitialState(stateFromLocalStorage);
  setIsInit(true);

  // handle refresh and navigating away/refreshing
  window.addEventListener('beforeunload', saveSnapshot);

  return () => {
   // in case of an SPA remove the event-listener
   window.removeEventListener('beforeunload', saveSnapshot);
   saveSnapshot();
  };
 }, [saveSnapshot, structure]);

 useEffect(() => {
  // first ue
  dispatch(getCurrentPresetStart({ type: 'columns', table }));

  // row click
  apiRef.current.subscribeEvent(
   'rowClick',
   (params: GridRowParams, event: MuiEvent<React.MouseEvent<HTMLElement>>) => {
    // console.log('rowClick', params, event);
    // if (params.field !== '__check__') {
    // eslint-disable-next-line prettier/prettier, no-param-reassign
    event.defaultMuiPrevented = true;
    // }
    if (params.row?.Id) {
     setCurrentId(params.row.Id);
    }

    return true;
   },
  );
  // row checkbox
  // apiRef.current.subscribeEvent(
  //  'rowSelectionChange',
  //  (
  //   i: GridRowSelectionModel,
  //   e: { defaultMuiPrevented?: boolean },
  //   details: GridCallbackDetails,
  //  ) => {
  //   const allRowIds = apiRef.current.getAllRowIds(); // Get all row IDs
  //   const rowId = allRowIds[Number(i[0])]; // Get row ID for the index
  //   const rowData = apiRef.current.getRow(rowId); // Get row data using row ID
  //   if (rowData?.Id) {
  //    setCurrentId(rowData.Id);
  //   }
  //   console.log('rowSelectionChange', i, e, details, rowData);

  //   return true;
  //  },
  // );
 }, []);

 const groupingColDef: GridGroupingColDefOverride = useMemo(
  () => ({
   headerName: t('global.group'),
   sortComparator: (v1, v2, cellParams1, cellParams2) => {
    console.log('sortComparator', v1, v2, cellParams1, cellParams2);
    return 1;
   },
  }),
  [apiRef],
 );

 return !initialState ? (
  <>loading state</>
 ) : (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="lt">
   <FieldsConfigProvider>
    {limitModalState?.anchorElement && (
     <LimitModal data={limitModalState} setOpen={setLimitModalState} />
    )}
    {translationModalState?.anchorElement && (
     <TranslationModal
      data={translationModalState}
      setOpen={setTranslationModalState}
      tableName={table}
     />
    )}
    {filterMenuState?.anchorElement && (
     <FilterMenu
      filterMenuState={filterMenuState}
      setOpen={setfilterMenuState}
      apiRef={apiRef}
     />
    )}

    <Typography
     sx={{
      mb: 2,
      fontSize: 16,
      fontWeight: 500,
      display: { xs: 'none', md: 'block' },
     }}
    >
     {t(`entities.${pageName}`)} ({rowCount})
    </Typography>

    <Box
     sx={{
      display: 'flex',
      height: { xs: '100%', md: 'calc(100% - 32px)' },
     }}
    >
     <Card
      style={{ width: '100%', flex: 1, transition: 'all 0.2s ease-in-out' }}
     >
      <CardContent
       sx={{
        display: 'flex',
        p: '0 !important',
        width: '100%',
        height: '100%',
       }}
      >
       <DataGridPremium
        // disableColumnFilter
        disableRowSelectionOnClick
        checkboxSelection
        groupingColDef={groupingColDef}
        //  headerFilters={!currentColumnsPreset?.isPro}
        slots={{
         ...props.slots,
         columnMenu: CustomColumnMenuWrapper,
         ...(!currentColumnsPreset?.isPro
          ? { pagination: DataGridPagination }
          : {}),
         toolbar: GridToolbar,
         ...gridSlotsIcons,
        }}
        slotProps={{
         loadingOverlay: {
          variant: 'linear-progress',
          noRowsVariant: 'skeleton',
         },
        }}
        initialState={initialState}
        disableVirtualization // performance !!!!!!!!
        rows={constructRows(rows)}
        columns={[checkboxCol, ...columnsState, actionsCol]}
        onColumnResize={handleColumnResize}
        onColumnOrderChange={handleColumnOrderChange}
        onRowGroupingModelChange={(newGroupingModel) => {
         setTimeout(() => {
          const groupColumns = apiRef.current
           .getAllColumns()
           .filter((col) => col.field.includes('row_group'))
           .map((col) => col.field);

          apiRef.current.autosizeColumns({
           //  expand: true,
           columns: groupColumns,
           includeHeaders: true,
           includeOutliers: true,
          });
         }, 100);
        }}
        loading={!!loading}
        apiRef={apiRef}
        rowCount={rowCount || 0}
        pagination
        sortModel={sortModel}
        onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
        filterModel={filter}
        filterMode={isServerMode ? 'server' : 'client'}
        filterDebounceMs={200}
        onFilterModelChange={(model, details) => {
         handleFilterModelChange(model, details, setFilter);
        }}
        sortingMode={isServerMode ? 'server' : 'client'}
        pageSizeOptions={[25, 50, 100, 250, 500]}
        paginationMode={isServerMode ? 'server' : 'client'}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        getRowHeight={() => 'auto'}
        //  rowHeight={currentColumnsPreset?.isPro ? 40 : 52}
        density={currentColumnsPreset?.isPro ? 'compact' : 'standard'}
        sx={(theme) => ({
         ...dataGridStyles(theme),
         '& .MuiDataGrid-row': {
          cursor: props.onRowClick || props.onCellClick ? 'pointer' : 'initial',
         },
         ...(currentColumnsPreset?.isPro
          ? {
             '& .limit-span': {
              fontSize: 12,
              padding: '2px 4px',
             },
             '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: 12,
             },
             '& .MuiDataGrid-cell': {
              fontSize: 12,
              px: '12px',
              display: 'flex',
              alignItems: 'center',
              // lineHeight: '21px',
              // py: '4px',
             },
            }
          : {}),
        })}
        // autoHeight
        getRowClassName={(params) => {
         let newClass =
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';

         if (
          params.row.Id === currentId &&
          ![params.row.Id, currentId].includes(undefined)
         ) {
          newClass = `${newClass} row-sidebar`;
         }
         newClass = `${newClass} isEnabled-${params?.row?.IsEnabled}`;
         return newClass;
        }}
        localeText={GRID_DEFAULT_LOCALE_TEXT}
       />
      </CardContent>
     </Card>
     <InfoSidebar
      apiRef={apiRef}
      currentId={currentId}
      setCurrentId={setCurrentId}
     />
     <FilterSidebar
      apiRef={apiRef}
      isOpen={filterSidebarOpen}
      handleClose={setFilterSidebarOpen}
      setColModalOpen={setColModalOpen}
     />
    </Box>

    {colModalOpen && (
     <ColModal
      isOpen={colModalOpen}
      handleClose={setColModalOpen}
      apiRef={apiRef}
     />
    )}

    <ResultModal
     setCreateModalOpen={setCreateModalOpen}
     isOpen={createModalOpen || modalState?.id !== -1}
     modalState={modalState}
     setModalState={setModalState}
     apiRef={apiRef}
    />
   </FieldsConfigProvider>
  </LocalizationProvider>
 );
});

XTable.displayName = 'XTable';

export default XTable;
